module.exports = "/** action-home.jsx */\nimport React from 'react';\nimport mui from 'mui';\nconst SvgIcon = mui.SvgIcon;\n\nconst ActionHome = React.createClass({\n  render: function() {\n    return (\n      <SvgIcon {...this.props}>\n        <path d=\"M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z\"></path>\n      </SvgIcon>\n    );\n  }\n});\n\nexport default ActionHome;\n\n\n/** Some other component. */\nimport ActionHome from './path/to/action-home.jsx';\n...\n<ActionHome/>\n...\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/raw-code/svg-icons-code.txt
 ** module id = 805
 ** module chunks = 0
 **/